import AllianceStyle from './AllianceStyle.module.css';
import { useEffect, useState } from "react";
import {useForm} from "react-hook-form";
import {responseMsg} from "../../common/ResponseMsg";
import Flex from '../../../shared/components/Flex';
import ModalButton from '../../../shared/components/ModalButton';
import useDevice from '../../../shared/hooks/useDevice';
import Grid from '../../../shared/components/Grid';
import GridChild from '../../../shared/components/GridChild';
import LabelInput from '../../../shared/components/LabelInput';
import ToggleSelect from '../../../shared/components/ToggleSelect';
import CheckBox from '../../../shared/components/CheckBox';
import Label from '../../../shared/components/Label';
import Spacer from '../../../shared/components/Spacer';
import { useAlert } from '../../../shared/components/AlertProvider';
import Text from '../../../shared/components/Text';

function AllianceEditModal({alliance, rendering}) {
    const { register, handleSubmit, formState: { isSubmitting, isDirty, errors }} = useForm({
        defaultValues : alliance
    });
    const [regions, setRegions] = useState([]);
    const [selectedRegion1, setSelectedRegion1] = useState({});
    const [checkBox, setCheckBox] = useState(alliance.regions.map(ele => ele.id));
    const device = useDevice();
    const isMobile = device !== 'desktop';
    const [useYn, setUseYn] = useState(alliance?.useYn ?? "");
    const showAlert = useAlert();

    const useYnOption = [
        {text: "사용", value: "Y"},
        {text: "미사용", value: "N"}
    ]

    const isAllChecked = () => {
        if (!selectedRegion1.id) return false;

        const childrenIds = regions
            .filter(ele => ele.parent === selectedRegion1.id)
            .map(ele => ele.id);

        return (
            childrenIds.length > 0 &&
            childrenIds.every(id => checkBox.includes(id))
        );
    };

    const onAllCheckHandler = (e) => {
        const isChecked = e.target.checked;

        const childrenIds = regions
            .filter(ele => ele.parent === selectedRegion1.id)
            .map(ele => ele.id);

        if (isChecked) {
            const set = new Set([...checkBox, ...childrenIds]);
            setCheckBox([...set]);
        } else {
            setCheckBox(checkBox.filter(id => !childrenIds.includes(id)));
        }
    };


    const onUpdateHandler = (formData) => {
        if (formData.allianceCode.trim() === '') {
            showAlert({title: "주의", text: "소속코드를 입력해주세요.", type: "warning" });
            return;
        } else if (formData.allianceName.trim() === '') {
            showAlert({title: "주의", text: "소속명을 입력해주세요.", type: "warning" });
            return;
        }

        fetch("/api/system/alliances",{
            method:"PATCH",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({...formData, regions: checkBox.join('/'), useYn: useYn}),
            })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "수정완료"});
                    rendering();

                }  else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            }).catch((error) => {
            });
    }

    const checkBoxChangeHandler = (event) => {
        const id = Number(event.target.name);
        const isChecked = checkBox.includes(id);
        let tmpMap = [];

        if (isChecked) {
            tmpMap = checkBox.filter(ele => ele !== id);
        } else {
            tmpMap = [...checkBox, id];
        }

        if (id === selectedRegion1.id) {
            const allRegions = regions
                .filter(ele => ele.parent === id)
                .map(ele => ele.id);

            if (isChecked) {
                tmpMap = tmpMap.filter(ele => !allRegions.includes(ele));
            } else {
                tmpMap = [...new Set([...tmpMap, ...allRegions])];
            }
        }

        setCheckBox(tmpMap);
    };


    const getRegionList = () => {
        return regions?.filter(ele => ele.depth === 2)?.map(ele => {

            const children =  alliance?.regions.filter(ele2 => ele2.parent == ele.id);

            return (
                <div 
                    key={ele.id} 
                    className={`${AllianceStyle.checkBoxWrap} ${selectedRegion1.id === ele.id && AllianceStyle.selected}`}
                    onClick={() => setSelectedRegion1(ele)}
                    style={{cursor:"pointer", fontSize: "17px", fontWeight: "600"}}
                >
                    <label htmlFor={ele.id} style={{cursor:"pointer"}}><Text size={14} weight={selectedRegion1.id === ele.id && AllianceStyle.selected ? "semibold" : "medium"}>{`${ele.name}(${children.length})`}</Text></label>
                </div>
            )
        })
    }

    const getRegionDtList = () => {
        if (!selectedRegion1.id) return null;

        const children = regions.filter(
            ele => ele.parent === selectedRegion1.id
        );

        return (
            <>
                <Flex alignItems="center" gap={10} style={{ fontSize: "17px", fontWeight: "600" }}>
                    <CheckBox
                        name="ALL"
                        checked={isAllChecked()}
                        onChange={onAllCheckHandler}
                    />
                    <label><Text size={14} weight={"medium"}>전체</Text></label>
                </Flex>

                {children.map(ele => (
                    <Flex
                        key={ele.id}
                        alignItems="center"
                        gap={10}
                        style={{ fontSize: "17px", fontWeight: "500" }}
                    >
                        <CheckBox
                            name={ele.id}
                            checked={checkBox.includes(ele.id)}
                            onChange={checkBoxChangeHandler}
                        />
                        <label htmlFor={ele.id}><Text size={14} weight={"medium"}>{ele.name}</Text></label>
                    </Flex>
                ))}
            </>
        );
    };

    const onDeleteHandler = () => {
        fetch(`/api/system/alliances/${alliance.id}`, {
            method: "DELETE",
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "삭제완료"});
                    rendering();

                } else if (json.code === responseMsg.ALLIANCE_FOUND_USER.code) {
                    showAlert({title: "경고", text: `해당 소속을 가지는 유저가 있습니다.\n아이디-이름 [${json.data.map(ele => `${ele.userId}-${ele.userNm}`).join('')}]`, type: "warning"});
                    rendering();

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }

    useEffect(() => {
        fetch("/api/system/codes/REGION",{
            method:"GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    setRegions(json.data)
                    setSelectedRegion1(json.data.find((ele) => ele.depth === 2));

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch(error => {
            });
    },[])

    return (
        <div>
            <form className="input_wrap">
                <Grid paddingX={0} gap={25}>
                    <GridChild>
                        <LabelInput id="allianceCode" label={'소속코드'} defaultValue={alliance.allianceCode} placeholder="소속코드를 입력해 주세요" {...register("allianceCode")} required />
                    </GridChild>
                    <GridChild>
                        <LabelInput id="allianceName" label={'소속명'} maxLength={200} placeholder="소속명을 입력해 주세요" defaultValue={alliance.allianceName} autoFocus {...register("allianceName")} required />
                    </GridChild>
                    <GridChild span={2}>
                        <Flex flexDirection='column' gap={8}>
                            <Label>시/도 권한</Label>
                            <Grid paddingX={0} gap={5} style={{
                                height: "150px", overflow: 'auto',
                                borderTop: "1px solid #E4E4E4",
                                borderBottom: "1px solid #E4E4E4",
                                paddingTop: "15px",
                                paddingBottom: "15px",
                                }}>
                                {getRegionList()}
                            </Grid>
                        </Flex>
                    </GridChild>
                    <GridChild span={2}>
                        <Flex flexDirection='column' gap={8}>
                            <Label>군/구 권한</Label>
                            <Grid paddingX={0} gap={12} templateColumn='1fr 1fr 1fr' style={{height: "84px", overflow: "auto", borderTop: "1px solid #E4E4E4", borderBottom: "1px solid #E4E4E4", paddingTop: "15px", paddingBottom: "15px"}}>
                                {getRegionDtList()}
                            </Grid>
                        </Flex>
                    </GridChild>
                </Grid>
            </form>

            <Spacer direction='vertical' size={22} />

            <ToggleSelect
                label="사용여부"
                name="usage_status"
                options={useYnOption}
                onChange={(value) => setUseYn(value)}
                initialValue={useYn}
            />

            <Spacer direction='vertical' size={22} />

            <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                <ModalButton type='update' onClick={handleSubmit(onUpdateHandler)} />
                <ModalButton type='delete' onClick={handleSubmit(onDeleteHandler)} /> 
                <ModalButton type='cancel' onClick={rendering} />
            </Flex> 
        </div>
    );
}

export default AllianceEditModal;